import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryPreview() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900"
            style={{ fontFamily: 'var(--font-heading)' }}>
            漫画分类
          </h2>
          <p className="text-sm text-foreground-400 mt-2">探索不同风格的韩漫世界</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-6 rounded-xl bg-background-50 hover:bg-primary-500 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-background-100 group-hover:bg-background-50/20 transition-colors">
                <i className={`${cat.icon} text-2xl text-primary-500 group-hover:text-background-50 transition-colors`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-background-50 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}